import {
  GET_WISHLIST,
  WISHLIST_ERROR,
  REMOVE_WISHLIST_ITEM,
  ADD_WISHLIST_ITEM
} from "./types";
import axios from "axios";
import { firebase } from "../../firebase";

export const getWishlist = () => async dispatch => {
  try {
    const token = await firebase.auth().currentUser.getIdToken();
    const { data } = await axios.post(
      `${process.env.REACT_APP_apiUrl}/getWishListItems`,
      {
        token
      }
    );
    dispatch({
      type: GET_WISHLIST,
      payload: data
    });
  } catch (error) {
    dispatch({
      type: WISHLIST_ERROR,
      payload: error
    });
  }
};

export const removeWishlistItem = productId => async dispatch => {
  try {
    const token = await firebase.auth().currentUser.getIdToken();
    await axios.post(`${process.env.REACT_APP_apiUrl}/removeWishListItem`, {
      productId,
      token
    });
    dispatch({
      type: REMOVE_WISHLIST_ITEM,
      payload: productId
    });
  } catch (error) {
    dispatch({
      type: WISHLIST_ERROR,
      error: error
    });
  }
};

export const addWishlistItem = (productId, product) => async dispatch => {
  try {
    const token = await firebase.auth().currentUser.getIdToken();
    await axios.post(`${process.env.REACT_APP_apiUrl}/addWishListItem`, {
      token,
      productId
    });
    dispatch({
      type: ADD_WISHLIST_ITEM,
      payload: product
    });
  } catch (error) {
    dispatch({
      type: WISHLIST_ERROR,
      error: error
    });
  }
};
